/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export const ZOOM_CLASS_NAME_MAP = {
  enter: 'zoom-enter',
  enterActive: 'zoom-enter-active',
  leave: 'zoom-leave',
  leaveActive: 'zoom-leave-active'
};

export const FADE_CLASS_NAME_MAP = {
  enter: 'fade-enter',
  enterActive: 'fade-enter-active',
  leave: 'fade-leave',
  leaveActive: 'fade-leave-active'
};

export const MODAL_MASK_CLASS_NAME = 'ant-modal-mask';
export const NZ_CONFIG_COMPONENT_NAME = 'modal';
